import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { map, filter, get } from 'lodash';
import { Form, Row, Col, Accordion, Card, Button } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from 'react-bootstrap/Pagination';
import PaginationComponent from '../Pagination';
import { useStyles } from '../../../styles/mapStylesCustom';

const OGCTabs = props => {
  const {
    collections,
    loadSubCollection,
    loadingCAT,
    loadLayer,
    loading,
    setLoading,
    offset,
    setOffset,
    currentPage,
    setCurrentPage,
    domainWithoutLastSlash
  } = props;
  const [filte, setFilte] = React.useState([]);
  const [collectionsIds, setCollectionsIds] = React.useState([
    ...new Set(map(collections, item => item.id))
  ]);

  const [schema] = React.useState('');
  const [limit, setLimit] = React.useState(100);
  const [elementePage, setElementPage] = React.useState(15);
  // const [search, setSearch] = React.useState('');
  const classes = useStyles();

  const changeElementLimit = event => {
    const value = Number(event.target.value.trim());
    setLimit(value);
  };
  const changeElementPerPage = event => {
    const value = Number(event.target.value.trim());
    setElementPage(value);
  };

  const handleSearch = event => {
    event.persist();
    // setSearch(event.target.value.trim());
    const searchRegex = new RegExp(event.target.value.trim(), 'i');
    const searchRegexSchema = new RegExp(schema, 'i');
    const filteredLayersSchema = filter(collections, layer => {
      const schemaArray = get(layer, 'title', '').split('.', 1);
      const NewSchema = searchRegexSchema.test(schemaArray[0]);
      return NewSchema;
    });
    const filteredLayers = filter(filteredLayersSchema, layer =>
      searchRegex.test(get(layer, 'title', '').split('.', 1))
    );
    const ids = [...new Set(map(filteredLayers, item => item.id))];
    setCollectionsIds(ids);
  };
  return (
    <>
      <Row>
        <Col xs={4} className="flex-row align-items-center">
          <Form.Control
            as="select"
            defaultValue={elementePage}
            className="mr-sm-2"
            id="Elements"
            onChange={event => changeElementPerPage(event)}
            custom
          >
            <option value="10">10 Elements per page</option>
            <option value="15">15 Elements per page</option>
            <option value="20">20 Elements per page</option>
            <option value="30">30 Elements per page</option>
            <option value="60">60 Elements per page</option>
          </Form.Control>
        </Col>
        <Col xs={4} className="flex-row align-items-center">
          <div className="position-relative">
            <FontAwesomeIcon
              className="position-absolute"
              style={{
                left: '12px',
                top: '10px'
              }}
              color="var(--gray-light)"
              icon="search"
            />
            <Form.Control
              type="text"
              name="search"
              className="pl-5"
              placeholder="Search Layer"
              onKeyUp={handleSearch}
            />
          </div>
        </Col>
      </Row>
      <PaginationComponent
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setFilte={setFilte}
        elementePage={elementePage}
        indexArray={collectionsIds}
        elementPaginttion={11}
      />
      <div className="col-12">
        <Accordion>
          {map(collections, element => {
            if (filte.includes(element.id)) {
              return (
                <Card padding="0px" key={element.id}>
                  <Card.Header className="py-0">
                    <Row className="align-items-center justify-content-center" xs={12}>
                      <Col sm={6} md={7} lg={8} xl={9}>
                        <Accordion.Toggle
                          as={Card}
                          className="py-0 border-0"
                          style={{ backgroundColor: 'transparent' }}
                          eventKey={element.id}
                          onClick={() =>
                            loadSubCollection(
                              element.id,
                              `&startindex=${offset * limit}&limit=${limit}`
                            )
                          }
                        >
                          {element.title}
                        </Accordion.Toggle>
                      </Col>
                      <Col sm={6} md={5} lg={4} xl={3}>
                        <Card className="py-0 border-0" style={{ backgroundColor: 'transparent' }}>
                          <div className="text-left">
                            <Button
                              variant="light"
                              className={classes.azulIpsilum}
                              title="Open"
                              onClick={() => loadLayer(element.id, limit, 'PUSH')}
                            >
                              <FontAwesomeIcon icon="file-alt" size="lg" />
                            </Button>
                            <Button
                              variant="light"
                              className={classes.azulIpsilum}
                              title="New Tab"
                              onClick={() => loadLayer(element.id, limit, 'TAB')}
                            >
                              <FontAwesomeIcon icon={['fa', 'link']} size="sm" />
                            </Button>
                            <Button
                              variant="light"
                              className={classes.azulIpsilum}
                              title="Open Modal"
                              onClick={() => loadLayer(element.id, limit, 'Modal')}
                            >
                              <FontAwesomeIcon icon={['fa', 'expand-arrows-alt']} />
                            </Button>
                          </div>
                        </Card>
                      </Col>
                    </Row>
                  </Card.Header>

                  <Accordion.Collapse eventKey={element.id}>
                    <Card.Body>
                      <Col xs={12}>
                        <h4>Tile Metadata</h4>{' '}
                        {loadingCAT && <Spinner animation="border" variant="primary" />}
                        <div className="row">
                          <div className="col-6">
                            <Row className="m-1" xs={12}>
                              <p>ID: {element.id}</p>
                            </Row>
                            <Row className="m-1" xs={12}>
                              <p>Description: {element.description}</p>
                            </Row>
                            <Row className="m-1" xs={12}>
                              <p>
                                Tile URL:{' '}
                                <a
                                  href={`${domainWithoutLastSlash}/collections/${
                                    element.id
                                  }/items?f=json&startindex=${offset * limit}&limit=${limit}`}
                                  target="_blank"
                                  rel="noreferrer noopener"
                                >
                                  <FontAwesomeIcon icon={['fa', 'link']} size="sm" /> Link
                                </a>
                              </p>
                            </Row>
                          </div>
                          <div className="col-6">
                            <Row className="m-1" xs={12}>
                              <p>Bounds</p>
                              <ul>
                                <li>Xmin: {element.extent.spatial.bbox[0][0]}</li>
                                <li>ymin: {element.extent.spatial.bbox[0][1]}</li>
                                <li>Xmax: {element.extent.spatial.bbox[0][2]}</li>
                                <li>Ymax: {element.extent.spatial.bbox[0][3]}</li>
                              </ul>
                            </Row>

                            <Row>
                              <Col xs={9} className="flex-row align-items-center">
                                <Form.Control
                                  as="select"
                                  defaultValue={limit}
                                  className="mr-sm-2"
                                  id="Elements"
                                  onChange={event => changeElementLimit(event)}
                                  custom
                                >
                                  <option value="10">10 Elements</option>
                                  <option value="20">20 Elements</option>
                                  <option value="50">50 Elements</option>
                                  <option value="100">100 Elements</option>
                                  <option value="1000">1000 Elements</option>
                                  <option value="2000">2000 Elements</option>
                                </Form.Control>
                              </Col>
                              <Col xs={3} className="flex-row align-items-center">
                                <Pagination>
                                  <Pagination.Prev
                                    disabled={loading}
                                    onClick={() => {
                                      setLoading(true);
                                      loadSubCollection(
                                        '',
                                        `&startindex=${(offset - 1) * limit}&limit=${limit}`
                                      ).finally(() => {
                                        setCurrentPage(1);
                                        setOffset(offset - 1);
                                        setLoading(false);
                                      });
                                    }}
                                  />
                                  <Pagination.Item active={!loading}>{offset}</Pagination.Item>
                                  <Pagination.Next
                                    disabled={loading}
                                    onClick={() => {
                                      setLoading(true);
                                      loadSubCollection(
                                        '',
                                        `&startindex=${(offset + 1) * limit}&limit=${limit}`
                                      ).finally(() => {
                                        setCurrentPage(1);
                                        setOffset(offset + 1);
                                        setLoading(false);
                                      });
                                    }}
                                  />
                                </Pagination>
                              </Col>
                            </Row>
                          </div>
                        </div>
                        <Form.Group as={Row}>
                          <Col sm={12}>
                            <Form.Control
                              type="text"
                              as="textarea"
                              disabled
                              value={`&startindex=${offset * limit}&limit=${limit}`}
                              rows={1}
                              // onChange={e => setStringSearch(e.target.value)}
                              name="search"
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              );
            }
            return false;
          })}
        </Accordion>
      </div>
    </>
  );
};

OGCTabs.defaultProps = {
  collections: [],
  loadSubCollection: () => {},
  loadingCAT: false,
  loadLayer: () => {},
  loading: false,
  setLoading: () => {},
  offset: 0,
  setOffset: () => {},
  currentPage: 1,
  setCurrentPage: () => {},
  domainWithoutLastSlash: ''
};
OGCTabs.propTypes = {
  collections: PropTypes.array,
  loadSubCollection: PropTypes.func,
  loadingCAT: PropTypes.bool,
  loadLayer: PropTypes.func,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  offset: PropTypes.number,
  setOffset: PropTypes.func,
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func,
  domainWithoutLastSlash: PropTypes.string
};
export default OGCTabs;
